import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import TakeOffOptionsButton from 'components/quote/TakeOffOptionsButton'
import QuoteTable from 'components/quote/Table'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import quoteActions from 'store/modules/quote'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  options: {
    flexGrow: 0,
  },
  content: {

  }
}))

const QuoteMaterials = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const quote = useSelector(selectors.quote.collection.item)
  const client = useSelector(selectors.quote.quoteClient)
  const project = useSelector(selectors.project.activeProject)
  const folderid = 'root'
  const tree = useSelector(selectors.quote.tree)
  const rows = useSelector(selectors.quote.rows)
  const markups = useSelector(selectors.quote.markups)
  const totals = useSelector(selectors.quote.totals)
  const inputVat = useSelector(selectors.quote.inputVatField)
  const inputMarkups = useSelector(selectors.quote.inputMarkupFields)
  const edits = useSelector(selectors.quote.edits)
  const inputs = useSelector(selectors.quote.inputs)
  const currency = useSelector(selectors.project.currency)
  const expanded = useSelector(selectors.quote.expanded)
  const editName = useSelector(selectors.quote.editName)
  const sortMode = useSelector(selectors.quote.sortMode)
  const materialRows = useSelector(selectors.quote.mergedMaterials)
  const onExportPDF = () => {
    console.log('--------------------------------------------')
    console.log('PDF MATERIALS')
  }
  
  useEffect(() => {
    dispatch(routerActions.addQueryParams({
      folderid: 'root',
    }))
  }, [])

  if(!folderid || !quote) {
    return null
  }

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography 
            variant="h6"
          >
            { quote.name } : Material Take Off Sheet
          </Typography>
        </div>
        {/* <div className={ classes.options }>
          <TakeOffOptionsButton
            onExportPDF={ onExportPDF }
          />
        </div> */}
      </div>
      <div className={ classes.content }>
        <QuoteTable
          clientView
          readOnly
          noTotals
          quote={ quote }
          tree={ tree }
          folderid={ folderid }
          rows={ materialRows }
          markups={ markups }
          totals={ totals }
          inputVat={ inputVat }
          inputMarkups={ inputMarkups }
          currency={ currency }
          edits={ edits }
          inputs={ inputs }
          expanded={ expanded }
          sortMode={ false }
          editName={ editName }
        />
      </div>
    </div>
  )

}

export default QuoteMaterials